export const MessageTabs = {
    INTERNAL: 'INTERNAL',
    TSP_CUST: 'TSP_CUST',
    EXTERNAL: 'EXTERNAL',
} as const;

export type MessageTab = (typeof MessageTabs)[keyof typeof MessageTabs];

export const isMessageTab = (tab: unknown): tab is MessageTab => {
    return typeof tab === 'string' && Object.values(MessageTabs).some((value) => value === tab);
};
